import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MissingInputError } from '@shared/errors/missing-input/missing-input.error';

@Component({
  selector: 'app-recipes-translation-fields-header',
  templateUrl: './recipes-translation-fields-header.component.html',
  styleUrls: ['./recipes-translation-fields-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, TranslateModule],
})
export class RecipesTranslationFieldsHeaderComponent implements OnInit {
  @Input() labels: {
    left: string;
    right?: string;
  };

  ngOnInit(): void {
    if (!this.labels) {
      throw new MissingInputError('labels');
    }
  }
}
